import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Programs from "./pages/Programs";
import Events from "./pages/Events";
import Blog from "./pages/Blog";
import Post from "./pages/Post";
import ProductDetail from "./pages/ProductDetail";
import NotFound from "./pages/NotFound";
import Socials from "./pages/Socials";
import Footer from "./components/Footer";
import WhatsAppAssistant from "./components/WhatsAppAssistant";

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const id = location.hash.replace("#", "");

    const scrollToSection = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    window.setTimeout(scrollToSection, 50);
  }, [location]);

  return null;
}

function App() {
  return (
    
      <div className="relative z-10">

        <ScrollToHash />

        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Post />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/socials" element={<Socials />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
        <WhatsAppAssistant />

      </div>
  );
}

export default App;
